import styled from 'styled-components';

export const Card = styled.div`
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 0;
  display: flex;
  align-items: center;
  overflow: hidden;
  transition: box-shadow 0.2s;

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
`;

export const ColorBlock = styled.div`
  width: 60px;
  height: 60px;
  background-color: ${(props) => props.$color || '#4B82CE'};
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px;
  border-radius: 8px;
`;

export const IconWrapper = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: ${(props) => props.$color || '#4B82CE'};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    width: 24px;
    height: 24px;
    color: #ffffff;
  }
`;

export const ContentSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
  padding: 20px 20px 20px 0;
`;

export const HeaderSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

export const Title = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const BadgesWrapper = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
`;

export const Badge = styled.span`
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;

  ${(props) => {
    switch (props.$type) {
      case 'status-enabled':
        return `
          background-color: #e7f3ff;
          color: #007bff;
        `;
      case 'status-disabled':
        return `
          background-color: #f5f5f5;
          color: #6c757d;
        `;
      case 'initial':
        return `
          background-color: #d1ecf1;
          color: #0c5460;
        `;
      case 'default':
        return `
          background-color: #e2e3e5;
          color: #383d41;
        `;
      case 'none':
        return `
          background-color: #f8f9fa;
          color: #6c757d;
        `;
      case 'lost':
        return `
          background-color: #f8d7da;
          color: #721c24;
        `;
      case 'converted':
        return `
          background-color: #d4edda;
          color: #155724;
        `;
      default:
        return `
          background-color: #e7f3ff;
          color: #296BCD;
        `;
    }
  }}
`;

export const Description = styled.p`
  font-size: 14px;
  color: #666;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
`;

export const ColorIndicator = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #666;
`;

export const ColorCircle = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: ${(props) => props.$color || '#4B82CE'};
  border: 1px solid #e0e0e0;
  flex-shrink: 0;
`;

export const ActionsSection = styled.div`
  display: flex;
  gap: 8px;
  flex-shrink: 0;
  padding: 20px 20px 20px 0;
`;

export const ActionButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${(props) => (props.$delete ? '#ffebee' : '#e7f3ff')};
  }
`;
